exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg {\n  display: flex;\n  align-items: center;\n  margin: 20px 0;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  padding: 10px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.015);\n  background: rgba(0, 0, 0, 0.025); }\n  .msg.negative svg {\n    color: #bb2525; }\n  .msg .icon {\n    margin-right: 12px; }\n", ""]);

// exports
